enum IndexedDBStore {
    LOGO_BLOB = 'logoBlob',
    IMAGE_ITEM = 'imageItem',
    COMMENT_ITEM = 'commentItem',
    COUNTRY = 'country',
    USER = 'user',
    CHECKLIST_MODEL = 'checklistModel',
    FILLED_CHECKLIST = 'filledChecklist',
    BUG_REPORT = 'bugReport',
    INSPECTING_COMPANY = 'inspectingCompany',
    INSPECTOR = 'inspector',
    DEPARTMENT = 'department',
    USER_DEPARTMENT_LINK = 'userDepartmentLink',
    CATEGORY = 'category',
    DOCUMENT_TREE_NODE = 'documentTreeNode',
    DOCUMENT_NODE = 'documentNode',
    DOCUMENT = 'document',
    MEMO_TEMPLATE = 'memoTemplate',
    FOLDER = 'folder',
    OBSERVATION_MODEL = 'observationModel',
    FILLED_OBSERVATION = 'filledObservation',
    OBSERVATION_CHAPTER = 'observationChapter',
    OBSERVATION_SUBCHAPTER = 'observationSubChapter',
    OBSERVATION_RULESET = 'observationRuleSet',
}

export default IndexedDBStore;